import { css } from "@emotion/css";
import moment from "moment";
import React, { useEffect, useState } from "react";
import SimpleTableField from "./SimpleTableField";

const ContentsTemplate = ({ updateContents, content = {} }) => {
    const [description, setDescription] = useState(content.description || "");
    const [liters, setLiters] = useState(content.liters || "");
    const [year, setYear] = useState(content.year || "");
    const [percentage, setPercentage] = useState(content.percentage || "");
    const [tariff, setTariff] = useState(content.tariff || "");
    const [country, setCountry] = useState(content.country || "");
    const [amount, setAmount] = useState(content.amount || "");
    const [value, setValue] = useState(content.value || "");
    const [totalValue, setTotalValue] = useState(content.totalValue || "");

    useEffect(() => {
        updateContents({
            description,
            liters,
            year,
            percentage,
            tariff,
            country,
            amount,
            value,
            totalValue
        });
    }, [
        description,
        liters,
        year,
        percentage,
        tariff,
        country,
        amount,
        value,
        totalValue
    ]);

    useEffect(() => {
        setTotalValue(value * amount);
    }, [value, amount]);

    return (
        <tr>
            <SimpleTableField
                placeholder="Omschrijving"
                value={description}
                setValue={setDescription}
                className={css`min-width:200px`}
            />
            <SimpleTableField
                placeholder="Liters"
                value={liters}
                setValue={setLiters}
                type="number"
                step="0.01"
                min="0"
                max="50"
                className={css`min-width:60px`}
            />
            <SimpleTableField
                placeholder="Jaar"
                value={year}
                setValue={setYear}
                type="number"
                step="1"
                min="0"
                max={moment().format("YYYY")}
                className={css`min-width:75px`}
            />
            <SimpleTableField
                placeholder="Percentage"
                value={percentage}
                setValue={setPercentage}
                type="number"
                step="0.1"
                min="0"
                max="100"
            />
            <SimpleTableField
                placeholder="Tariff"
                value={tariff}
                setValue={setTariff}
                type="number"
                className={css`min-width:110px`}
            />
            <SimpleTableField
                placeholder="Land"
                value={country}
                setValue={setCountry}
            />
            <SimpleTableField
                placeholder="Aantal"
                value={amount}
                setValue={setAmount}
                type="number"
                min="0"
                max="1000"
            />
            <SimpleTableField
                placeholder="Waarde"
                value={value}
                setValue={setValue}
                type="number"
                min="0"
                step="0.01"
                className={css`min-width:70px`}
            />
            <SimpleTableField
                placeholder="Totaal"
                value={totalValue}
                setValue={setTotalValue}
                disabled={true}
            />
        </tr>
    );
};

export default ContentsTemplate;
